import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ProjectSearchResponse} from '../models/project';
import {Observable} from 'rxjs';

export interface ProjectService {
    searchProjectsWithoutReference(search: string): Observable<ProjectSearchResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectServiceImpl implements ProjectService{
    protected http = inject(HttpClient);


    searchProjectsWithoutReference(search: string): Observable<ProjectSearchResponse[]> {
        return this.http.get<ProjectSearchResponse[]>(`/api/v1/projects`, {
            params: {search}
        });
    }

}
